import { Pill } from "src/base-components/Pill";
import { BeMappedNode } from "src/constants/NodeDataTypes";
import { getNodeIconFromNode } from "src/constants/NodeTypeIcons";
import { Tooltip } from "src/design-system/Tooltip";

export const NodePill: React.FC<{ node: BeMappedNode }> = ({ node }) => (
  <Tooltip placement="bottom" title={node.data.label} asChild>
    <Pill size="sm" variant="gray" fullWidth>
      {getNodeIconFromNode(node, "xs")}
      <Pill.Text>{node.data.label}</Pill.Text>
    </Pill>
  </Tooltip>
);
